import axios from 'axios';
import md5 from 'md5';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardControlKeyIcon from '@mui/icons-material/KeyboardControlKey';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import Autolettura from './steps/Autolettura';
import RecapLettura from './steps/RecapLettura';
import ReactCardFlip from 'react-card-flip';

function LettureGas() {
  const navigate = useNavigate()
  const customerCode = useSelector((user) => user.gas.info.customer_code)
  const customerId = useSelector((user) => user.gas.info.customer_id)
  const pdr = useSelector((user) => user.gas.info.pod_code)
  const tknPvt = md5(customerId + 'oYmAIdtki%lu')
  const [letture, setLetture] = useState()
  const [autoLetture, setAutoLetture] = useState()
  const [counter, setCounter] = useState(6)
  const [step, setStep] = useState(0)
  const [data, setData] = useState({})
  const [flipped, setFlipped] = useState(false)

  useEffect(() => {
    init()
    getAutoletture()
  },[counter])

  const init = async () => {
    const deliveryApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryGas.php?codice_cliente=${customerCode}`
    const { data } = await axios.get(deliveryApi)
    setLetture(data.data.reverse().slice(0, 12));
  }

  const getAutoletture = async () => {
    const autolettureApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getAutolettureGas.php?customer_id=${customerId}&tkn_pvt=${tknPvt}&pdr=${pdr}`
    const { data } = await axios.get(autolettureApi)
    setAutoLetture(data.data.reverse().slice(0,12))
  }
  return (
    <>
      <div className="headerLetture">
        {step === 0 ? (
          <>
            <ArrowBackIcon onClick={() => navigate(-1)}/>
            <p>Letture</p>
          </>
        ) : (
          <>
            <ArrowBackIcon onClick={() => setStep(step - 1)}/>
            <p>Autolettura</p>
          </>
        )}
        
      </div>
      {step === 0 ? (
        <div className='letture gas'>
          <div className="text">
            <p className="main">Letture</p>
            <p className="secondary">
              Nella tabella qui in basso troverai le ultime letture reali relative al codice PDR {pdr}, dalla più recente alla meno recente.            
            </p>
          </div>
          <div className="switchLettura" onClick={() => setFlipped(!flipped)}>
            {flipped ? (
              <p>Vai alle tue letture</p>
            ) : (
              <p>Vai alle tue autoletture</p>
            )}
          </div>
          <ReactCardFlip isFlipped={flipped} flipDirection='horizontal'>
            <div className="lettureBox">
              <div className="headerBox">
                <ul>
                  <li>Data</li>
                  <li>Precedente</li>
                  <li>Attuale</li>
                  <li>TOT</li>
                </ul>
              </div>
              <div className="bodyBox">
                {letture && letture.slice(0,counter).map((r) => (
                  <div className="line" key={r.pod_id}>
                    <ul>
                      <li>{DateTime.fromISO(r.mese, {locale: 'it'}).toFormat(`MMMM`)}</li>
                      <li>{parseFloat(r.let_prec)}</li>
                      <li>{parseFloat(r.let_att)}</li>
                      <li>{parseFloat(r.consumo_mc)}</li>
                    </ul>
                  </div>
                ))}
              </div>
              <div className="moreInfo">
                <p className='more' onClick={() => counter === 6 ? setCounter(12) : setCounter(6)}>{counter === 6 ? 'Mostra di più' : 'Mostra meno'}{counter === 6 ? <KeyboardArrowDownIcon /> : <KeyboardControlKeyIcon/>}</p>
              </div>
            </div>
            <div className="lettureBox">
              <div className="headerBox">
                <ul>
                  <li>Data</li>
                  <li>Lettura</li>
                </ul>
              </div>
              <div className="bodyBox">
                {autoLetture && autoLetture.slice(0,counter).map((r) => (
                  <div className="line" key={r.pod_id}>
                    <ul>
                      <li>{DateTime.fromISO(r.giorno, {locale: 'it'}).toFormat(`MMMM`)}</li>
                      <li>{parseFloat(r.lettura)}</li>
                    </ul>
                  </div>
                ))}
              </div>
              <div className="moreInfo">
                <p className='more' onClick={() => counter === 6 ? setCounter(12) : setCounter(6)}>{counter === 6 ? 'Mostra di più' : 'Mostra meno'}{counter === 6 ? <KeyboardArrowDownIcon /> : <KeyboardControlKeyIcon/>}</p>
              </div>
            </div>
          </ReactCardFlip>
          
          <div className="buttonContainer">
            <button onClick={() => setStep(step + 1)}>Invia autolettura <ArrowForwardIos/></button>
          </div>
        </div>
      ) : step === 1 ? (
        <Autolettura setData={setData} setStep={setStep} step={step} data={data} />
      ) : <RecapLettura data={data} />}
    </>
  );
}

export default LettureGas;
